<template>
    <header class="w-full h-22 z-30 transition-colors duration-300 sticky top-0 px-4" :class="[
        isScrolled ? 'bg-primary' : 'bg-gradient-to-b from-transparent backdrop-blur-sm to-transparent',
        { 'bg-primary': $route.name != 'home' && $route.name != 'about' }
    ]">
        <div class="container mx-auto py-2 px-3 md:px-0">
            <div class="flex items-center justify-between">
                <RouterLink :to="{ name: 'home' }">
                    <img
                        :src="companyLogo"
                        class="w-12"
                        alt=""
                        srcset=""
                        style="filter: brightness(0) invert(1)"
                    >
                </RouterLink>
                <!-- Hamburger button for mobile -->
                <button @click="isMenuOpen = !isMenuOpen" class="md:hidden text-white focus:outline-none">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8" fill="none" viewBox="0 0 24 24"
                        stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M4 6h16M4 12h16M4 18h16" />
                    </svg>
                </button>
                <!-- Desktop Nav -->
                <ul class="hidden md:block">
                    <li class="flex items-center space-x-8 text-white text-lg">
                        <RouterLink :to="{ name: 'home' }" class="relative group"
                            :class="{ 'bg-white text-primary px-4 py-2 rounded-2xl text-base font-semibold': $route.name === 'home' }">
                            Accueil
                        </RouterLink>

                        <RouterLink :to="{ name: 'blog' }" class="relative group"
                            :class="{ 'bg-white text-primary px-4 py-2 rounded-2xl text-base font-semibold': $route.name === 'blog' }">
                            Actualités
                        </RouterLink>
                        <template v-if="authStore.isAuthenticated">
                            <RouterLink :to="{ name: 'accords' }" class="relative group"
                                :class="{ 'bg-white text-primary px-4 py-2 rounded-2xl text-base font-semibold': $route.name === 'accords' }">
                                Accords
                            </RouterLink>
                        </template>

                        <template v-if="!authStore.isAuthenticated">
                            <button @click="OpenModal = true" class="flex space-x-2 items-center" type="button">
                                Accords
                            </button>
                        </template>

                        <template v-if="!authStore.isAuthenticated">
                            <RouterLink :to="{ name: 'adhesion' }" class="relative group"
                                :class="{ 'bg-white text-primary px-4 py-2 rounded-2xl text-base font-semibold': $route.name === 'adhesion' }">
                                Adhésion
                            </RouterLink>
                        </template>

                    </li>
                </ul>
                <div class="hidden md:block">
                    <ul>
                        <li class="flex items-center space-x-8 text-white text-lg">
                            <button @click="OpenContactModal = true" class="flex space-x-2 items-center">
                                <svg xmlns="http://www.w3.org/2000/svg" width="19" height="13" fill="none">
                                    <path fill="#fff"
                                        d="M1.016 12.696c.106-.095.197-.177.29-.257L4.32 9.82l2.535-2.207c.267-.233.536-.464.801-.7.057-.05.096-.048.155-.003.28.21.553.433.849.62.386.244.813.294 1.259.182.354-.089.63-.31.91-.527.12-.095.245-.186.364-.283.053-.043.09-.047.145 0 .791.692 1.584 1.38 2.377 2.069l2.507 2.177 1.681 1.462c.026.023.048.05.08.084-.204.13-.41.207-.63.25-.455.09-.916.04-1.375.046-.72.01-1.44.003-2.16.003l-2.069-.001H3.352c-.49-.002-.98.004-1.468-.012-.303-.01-.584-.117-.868-.285ZM.969.323c.098-.052.18-.103.266-.14.279-.122.569-.182.873-.181 1.147.002 2.293.001 3.439 0L9.405 0l4.699.003c.916 0 1.832 0 2.749-.003.355 0 .694.065 1.01.232.026.014.05.031.09.055-.126.1-.239.191-.354.28a9527.09 9527.09 0 0 1-3.987 3.07l-3.48 2.676c-.077.059-.152.12-.23.179-.263.202-.532.204-.798.003l-1.9-1.44-2.958-2.238L1.068.406l-.1-.083ZM12.176 6.153l.613-.474 4.184-3.224 1.7-1.307c.049-.038.077-.048.11.023.14.292.218.597.218.923V10.9c0 .308-.07.598-.193.877-.012.027-.03.052-.054.095l-6.578-5.72ZM.228 11.895c-.069-.218-.142-.405-.184-.6a2.283 2.283 0 0 1-.04-.479C0 7.917.001 5.018 0 2.12c0-.298.062-.578.174-.852.035-.085.062-.09.133-.036.672.512 1.347 1.021 2.02 1.531L4.942 4.74c.6.453 1.198.909 1.798 1.36.067.051.069.08.004.137-.766.662-1.53 1.327-2.295 1.992L.58 11.594c-.107.093-.215.185-.352.301Z" />
                                </svg>
                                <span>Contact</span>
                            </button>
                            <button @click="OpenModal = true" v-if="!authStore.isAuthenticated"
                                class="flex space-x-2 items-center" type="button">
                                <svg xmlns="http://www.w3.org/2000/svg" width="17" height="20" fill="none">
                                    <path fill="#fff" fill-rule="evenodd"
                                        d="M10.96 10.225c3.028 0 5.506 2.518 5.506 5.594v4.098H.167v-4.098c0-3.077 2.478-5.594 5.507-5.594h5.285ZM8.312.125c2.421 0 4.377 1.998 4.377 4.447 0 2.452-1.956 4.44-4.377 4.444-2.417-.003-4.37-1.992-4.37-4.444 0-2.45 1.953-4.445 4.37-4.447Z"
                                        clip-rule="evenodd" />
                                </svg>
                                <span>Connexion</span>
                            </button>
                            <!-- when logged in dropdown -->
                            <div v-if="authStore.isAuthenticated" class="relative group"
                                @click="showDropdown = !showDropdown"
                                @click.self="showDropdown = false"
                                v-click-outside="() => {
                                    showDropdown = false;
                                }">
                                <button
                                    class="flex items-center text-sm bg-gray-800 rounded-full focus:ring-4 focus:ring-gray-300"
                                    type="button" id="dropdownUserAvatarButton">
                                    <span class="sr-only">Open user menu</span>
                                    <img class="w-9 h-9 rounded-full object-cover border-2 border-white shadow"
                                        :src="authStore.user?.image" alt="">
                                </button>
                                <transition name="fade">
                                    <div v-if="showDropdown"
                                        class="absolute right-0 mt-2 w-64 bg-white rounded-xl shadow-lg ring-1 ring-black/5 z-50">
                                        <div class="flex items-center gap-3 px-5 py-4 border-b">
                                            <img class="w-12 h-12 rounded-full object-cover border"
                                                :src="authStore.user?.image" alt="">
                                            <div class="min-w-0">
                                                <div class="font-semibold text-gray-900 truncate">{{
                                                    authStore.user?.first_name }} {{
                                                    authStore.user?.last_name }}</div>
                                                <div class="text-xs text-gray-500 truncate">{{ authStore.user?.email }}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="py-2">
                                            <RouterLink :to="{ name: 'profile' }"
                                                class="flex items-center gap-2 px-5 py-2 text-gray-700 hover:bg-gray-100 transition rounded-lg">
                                                <svg class="w-5 h-5 text-primary" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                                                    <path stroke-linecap="round" stroke-linejoin="round" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                                                </svg>
                                                <span>Profil</span>
                                            </RouterLink>
                                            <button @click="handleLogout"
                                                class="flex items-center gap-2 px-5 py-2 w-full text-left text-gray-700 hover:bg-red-50 hover:text-primary transition rounded-lg">
                                                <svg class="w-5 h-5 text-primary" fill="none" stroke="currentColor"
                                                    stroke-width="2" viewBox="0 0 24 24">
                                                    <path stroke-linecap="round" stroke-linejoin="round"
                                                        d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                                                </svg>
                                                <span>Déconnexion</span>
                                            </button>
                                        </div>
                                    </div>
                                </transition>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>

            <template v-if="isMenuOpen">
                <div class="h-svh w-full bg-black/80 backdrop-blur-sm fixed top-0 left-0 z-50 transition-all duration-300 ease-out shadow-2xl"
                    :class="{ 'opacity-0': !isMenuOpen, 'opacity-100': isMenuOpen }" @click.self="isMenuOpen = false">
                    <transition name="fade">
                        <div class="h-full w-10/12 bg-primary bg-center p-3 md:p-8 transform transition-transform duration-300 ease-out"
                            :class="{ '-translate-x-full': !isMenuOpen, 'translate-x-0': isMenuOpen }">
                            <div class="flex flex-col justify-between h-full">
                                <div>
                                    <div class="flex justify-between items-center mb-12">
                                        <RouterLink :to="{ name: 'home' }">
                                            <img :src="logo" class="w-12" alt="" srcset="">
                                        </RouterLink>
                                        <button @click="isMenuOpen = false" class="text-white" type="button">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"
                                                viewBox="0 0 24 24" stroke="currentColor">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                    d="M6 18L18 6M6 6l12 12" />
                                            </svg>
                                        </button>
                                    </div>
                                    <ul class="flex flex-col space-y-0 text-white text-lg">
                                        <RouterLink :to="{ name: 'home' }" class="relative group py-2"
                                            :class="{ 'text-white font-bold': $route.name === 'home', 'text-white/80 hover:text-white': $route.name !== 'home' }"
                                            @click="isMenuOpen = false">
                                            <div class="flex items-center space-x-2 py-2 px-4 rounded-lg"
                                                :class="{ 'bg-white text-primary': $route.name === 'home' }">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                                                    fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                    <path stroke-linecap="round" stroke-linejoin="round"
                                                        stroke-width="2"
                                                        d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                                                </svg>
                                                <span>Accueil</span>
                                            </div>

                                        </RouterLink>

                                        <RouterLink :to="{ name: 'blog' }" class="relative group py-2"
                                            :class="{ 'text-white font-bold': $route.name === 'blog', 'text-white/80 hover:text-white': $route.name !== 'blog' }"
                                            @click="isMenuOpen = false">
                                            <div class="flex items-center space-x-2 py-2 px-4 rounded-lg"
                                                :class="{ 'bg-white text-primary': $route.name === 'blog' }">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                                                    fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                    <path stroke-linecap="round" stroke-linejoin="round"
                                                        stroke-width="2"
                                                        d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z" />
                                                </svg>
                                                <span>Actualités</span>
                                            </div>
                                        </RouterLink>

                                        <template v-if="authStore.isAuthenticated">
                                            <RouterLink :to="{ name: 'accords' }" class="relative group py-2"
                                                :class="{ 'text-white font-bold': $route.name === 'accords', 'text-white/80 hover:text-white': $route.name !== 'accords' }"
                                                @click="isMenuOpen = false">
                                                <div class="flex items-center space-x-2 py-2 px-4 rounded-lg"
                                                    :class="{ 'bg-white text-primary': $route.name === 'accords' }">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                                                        fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                        <path stroke-linecap="round" stroke-linejoin="round"
                                                            stroke-width="2"
                                                            d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                                    </svg>
                                                    <span>Accords</span>
                                                </div>
                                            </RouterLink>
                                        </template>

                                        <template v-if="!authStore.isAuthenticated">
                                            <button
                                                class="flex space-x-2 items-center text-white/80 hover:text-white transition-colors duration-200 py-2 px-4 rounded-lg"
                                                type="button" @click="() => {
                                                    isMenuOpen = false;
                                                    OpenModal = true;
                                                }">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                                                    fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                    <path stroke-linecap="round" stroke-linejoin="round"
                                                        stroke-width="2"
                                                        d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                                </svg>
                                                <span>Accords</span>
                                            </button>
                                        </template>

                                        <button class="relative group py-2"
                                            :class="{ 'text-white font-bold': $route.name === 'contact', 'text-white/80 hover:text-white': $route.name !== 'contact' }"
                                            @click="() => {
                                                isMenuOpen = false;
                                                OpenContactModal = true;
                                            }">
                                            <div class="flex items-center space-x-2 py-2 px-4 rounded-lg"
                                                :class="{ 'bg-white text-primary': $route.name === 'contact' }">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                                                    fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                    <path stroke-linecap="round" stroke-linejoin="round"
                                                        stroke-width="2"
                                                        d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                                                </svg>
                                                <span>Contact</span>
                                            </div>
                                        </button>
                                        <div class="py-3 border-t border-white/10"></div>
                                        <div v-if="!authStore.isAuthenticated" class="grid grid-cols-2 gap-3">
                                            <button @click="() => {
                                            isMenuOpen = false;
                                            OpenModal = true;
                                        }" class="relative group"
                                            :class="{ 'text-white font-bold': $route.name === 'login', 'text-white/80 hover:text-white': $route.name !== 'login' }"
                                            type="button">
                                            <div class="flex items-center space-x-1 py-2 px-3 rounded-lg border border-white bg-white/5"
                                                :class="{ 'bg-white text-primary': $route.name === 'login' }">
                                                <div>
                                                    <svg class="w-4 h-4" xmlns="http://www.w3.org/2000/svg"
                                                        fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                        <path stroke-linecap="round" stroke-linejoin="round"
                                                            stroke-width="2"
                                                            d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z" />
                                                    </svg>
                                                </div>
                                                <span class="text-md">Connexion</span>
                                            </div>
                                        </button>
                                        <button @click="() => {
                                            isMenuOpen = false;
                                            $router.push({ name: 'adhesion' });
                                        }" class="relative group"
                                            :class="{ 'text-white font-bold': $route.name === 'adhesion', 'text-white/80 hover:text-white': $route.name !== 'adhesion' }"
                                            type="button">
                                            <div class="flex items-center space-x-1 py-2 px-3 rounded-lg bg-white text-primary border border-white "
                                                :class="{ 'bg-white !text-primary': $route.name === 'adhesion' }">
                                                <svg class="w-4 h-4" xmlns="http://www.w3.org/2000/svg" 
                                                    fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                    <path stroke-linecap="round" stroke-linejoin="round"
                                                        stroke-width="2"
                                                        d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
                                                </svg>
                                                <span class="text-md">Adhésion</span>
                                            </div>
                                        </button>
                                        </div>
                                        
                                        <!-- when logged in -->
                                        <div v-else
                                            class="flex items-center gap-3 p-3 rounded-xl bg-white/90 mt-8 shadow">
                                            <img :src="authStore.user?.image || 'https://via.placeholder.com/40'"
                                                class="w-8 h-8 rounded-full object-cover" alt="User Avatar">
                                            <div class="flex-1 min-w-0">
                                                <div class="text-xs font-semibold text-gray-900 truncate">{{
                                                    authStore.user?.first_name }} {{
                                                    authStore.user?.last_name }}</div>
                                                <div class="text-xs text-gray-500 truncate">{{ authStore.user?.email }}
                                                </div>
                                            </div>
                                            <RouterLink @click="() => {
                                                isMenuOpen = false;
                                            }" :to="{ name: 'profile' }"
                                                class="text-gray-400 hover:text-red-500 focus:outline-none ml-1"
                                                title="Déconnexion">
                                                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none"
                                                    viewBox="0 0 24 24" stroke="currentColor">
                                                    <path stroke-linecap="round" stroke-linejoin="round"
                                                        stroke-width="2"
                                                        d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.17-.1.3-.24.41-.37z" />
                                                    <path stroke-linecap="round" stroke-linejoin="round"
                                                        stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                                </svg>
                                            </RouterLink>
                                            <button @click="handleLogout"
                                                class="text-gray-400 hover:text-red-500 focus:outline-none ml-1"
                                                title="Déconnexion">
                                                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none"
                                                    viewBox="0 0 24 24" stroke="currentColor">
                                                    <path stroke-linecap="round" stroke-linejoin="round"
                                                        stroke-width="2"
                                                        d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                                                </svg>
                                            </button>
                                        </div>
                                    </ul>
                                </div>

                                <!-- App Banner -->
                                <div v-if="false"
                                    class="p-3 mt-8 bg-gray-200 bg-opacity-25 rounded-2xl flex justify-center items-center">
                                    <div class="md:p-4 bg-white border w-full h-full p-2 shadow-lg rounded-2xl">
                                        <div class="text-center mb-4">
                                            <h3 class="text-primary text-lg font-bold mb-2">Téléchargez notre
                                                application</h3>
                                            <p class="text-gray-600 text-sm">Accédez à tous les services UNAC depuis
                                                votre
                                                smartphone</p>
                                        </div>
                                        <AppCountdown size="sm" />
                                        <div v-if="false" class="flex items-center justify-center space-x-4">
                                            <RouterLink to="" target="_blank" class="block transition transform hover:scale-105">
                                                <img :src="appleStore" alt="App Store"
                                                    class="h-10">
                                            </RouterLink>
                                            <RouterLink to="" target="_blank" class="block transition transform hover:scale-105">
                                                <img :src="googlePlay" alt="Google Play"
                                                    class="h-10">
                                            </RouterLink>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </transition>

                </div>
            </template>
        </div>
    </header>
    <LoginPopup v-model="OpenModal" />
    <ContactPopup v-model="OpenContactModal" />
    <ConfirmDialog v-model="showLogoutConfirm" @confirm="confirmLogout" />
</template>

<script setup>
import { useAuthStore } from '../stores/auth';
import { useRouter } from 'vue-router';
import { ref, onMounted, onUnmounted,computed  } from 'vue';
import { useRoute } from 'vue-router';
import LoginPopup from './LoginPopup.vue';
import ContactPopup from './ContactPopup.vue';
import ConfirmDialog from './ConfirmDialog.vue';
import { initFlowbite } from 'flowbite';
import logo from '../../assets/images/svg/logo-dark.svg'
import appleStore from '../../assets/images/svg/app-store-btn.svg'
import googlePlay from '../../assets/images/svg/google-play-btn.svg'
import AppCountdown from './AppCountdown.vue';

const authStore = useAuthStore();
const router = useRouter();
const isMenuOpen = ref(false);
const OpenModal = ref(false);
const OpenContactModal = ref(false);
const showLogoutConfirm = ref(false);
const isScrolled = ref(false);
const route = useRoute();
const showDropdown = ref(false);

const handleScroll = () => {
    isScrolled.value = window.scrollY > 50;
};

const companyLogo = computed(() => {
    const company = JSON.parse(localStorage.getItem('selectedCompany'));
    if(company){
        return company?.header_logo_url;
    }else{
        return logo;
    }
});

const handleResize = () => {
    if (window.innerWidth >= 768) {
        isMenuOpen.value = false;
    }
};

window.addEventListener('resize', handleResize);

const handleLogout = async () => {
    showLogoutConfirm.value = true;
};

const confirmLogout = async () => {
    try {
        await authStore.logout();
        router.push('/');
    } catch (error) {
        console.error('Logout failed:', error);
    }
};

onMounted(() => {
    initFlowbite();
    window.addEventListener('scroll', handleScroll);
    handleScroll();
});

onUnmounted(() => {
    window.removeEventListener('scroll', handleScroll);
});

document.addEventListener('DOMContentLoaded', () => {
    const btn = document.querySelector('#login-modal');
    if (btn) {
        btn.click();
    }
});
</script>

<style scoped>
/* Add smooth transition for the logo */
img {
    transition: all 0.3s ease;
}
</style>